import { ELeaveDaysStatus } from '../../../shared/enums/leave-days/ELeaveDays';
import { IBaseModel } from '../../../shared/interfaces/shared/IBase';
import { IPagination } from '../../../shared/interfaces/shared/IPagination';
import { ILeaveDay } from '../../../shared/interfaces/leave-days/ILeaveDay';
import { requests } from '../../../utils/api/api.service';
import { LEAVE_DAYS_URL } from '../../../utils/api/endpoints';

export const AdminLeaveDaysService = {
  get: (pagination: IPagination): Promise<IBaseModel<ILeaveDay[]>> =>
    requests.get(LEAVE_DAYS_URL, pagination),
  create: (vacation: ILeaveDay): Promise<ILeaveDay> =>
    requests.post(LEAVE_DAYS_URL, vacation),
  update: (vacationId: number, vacation: ILeaveDay): Promise<ILeaveDay> =>
    requests.put(`${LEAVE_DAYS_URL}/${vacationId}`, vacation),
  delete: (vacationId: number): Promise<ILeaveDay> =>
    requests.delete(`${LEAVE_DAYS_URL}/${vacationId}`),
  updateStatus: (
    vacationId: number,
    status: ELeaveDaysStatus,
  ): Promise<ILeaveDay> =>
    requests.put(`${LEAVE_DAYS_URL}/status/${vacationId}`, { status }),
};
